var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import '@styles/webdesktop/stylesheets/checkbox.scss';
import React, { useId } from 'react';
import { SvgIcon } from '../SvgIcon/SvgIcon';
import { SvgIconType } from '../SvgIcon/SvgIconType';
export const Checkbox = (_a) => {
    var { checked, onChange, disabled = false, id } = _a, restProps = __rest(_a, ["checked", "onChange", "disabled", "id"]);
    const checkboxId = id !== null && id !== void 0 ? id : useId();
    const checkboxElement = (React.createElement("span", Object.assign({ className: "checkbox" }, restProps),
        React.createElement("input", { type: "checkbox", id: checkboxId, checked: checked, onChange: onChange, disabled: disabled }),
        checked ? (React.createElement("span", { className: "checkbox-checked-icon-default" },
            React.createElement(SvgIcon, { icon: SvgIconType.Checkbox }))) : (React.createElement("span", { className: "checkbox-unchecked-icon-default" }))));
    return checkboxElement;
};
